<template>
    <v-layout style="background-color: #F5F9FB;">
        <Navigation/>
        <Loader v-if="loadingGlobal"/>
        <v-layout wrap column class="layout-add layout-add--max_width" v-else>
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Редактирование сайта</v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading" @click="sendForm">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <SEO :seo="seo" :validator="$validator"/>
                <Social :social="social"/>
                <Carousel :carousel="carousel" :refresh-carousel="refreshCarousel"/>
                <TextBlock :text-block="textBlock" :refresh-text-block="refreshTextBlock"/>
                <Menu :menu.sync="menu"/>
                <News :news="news"/>
                <Contacts :contacts="contacts" :validator="$validator"/>
            </v-form>
        </v-layout>
    </v-layout>
</template>

<script>
    import Project from '../../api/project'
    import CarouselAPI from '../../api/carousel'
    import TextBlockAPI from '../../api/textblock'
    import Navigation from './Navigation'
    import SEO from './SEO'
    import Social from './Social'
    import Carousel from './Carousel/Layout'
    import TextBlock from './TextBlock/Layout'
    import Menu from './Menu'
    import News from './News'
    import Contacts from './Contacts'
    import Loader from '../../components/Loader/Layout'

    export default {
        name: 'siteLayout',
        components: {
            Navigation,
            SEO,
            Social,
            Carousel,
            TextBlock,
            Menu,
            News,
            Contacts,
            Loader
        },
        data: () => ({
            loading: false,
            loadingGlobal: false,
            seo: {},
            social: {},
            carousel: {},
            textBlock: {},
            menu: {},
            news: {},
            contacts: {},
            branches: []
        }),
        created () {
            this.loadingGlobal = true

            this.setHeaderTitle('Управление сайтом')

            Project
                .get()
                .then(response => {
                    this.seo = response.data.data.seo
                    this.social = response.data.data.social
                    this.carousel = response.data.data.carousel
                    this.textBlock = response.data.data.text_block
                    this.menu = response.data.data.menu
                    this.news = response.data.data.news_events
                    this.contacts = response.data.data.contacts
                    this.branches = response.data.data.branches
                })
                .catch(error => new Error(error))
                .finally(() => this.loadingGlobal = false)
        },
        methods: {
            refreshCarousel () {
                CarouselAPI
                    .getAll()
                    .then(response => this.carousel = response.data.data)
                    .catch(error => new Error(error))
            },
            refreshTextBlock () {
                TextBlockAPI
                    .getAll()
                    .then(response => this.textBlock = response.data.data)
                    .catch(error => new Error(error))
            },
            sendForm () {
                this.$validator
                    .validateAll()
                    .then(isValid => {
                        if (!isValid) return

                        this.loading = true

                        Project
                            .save(this.$data)
                            .then(response => this.$store.commit('showSnackbar', {
                                'text': response.data.data,
                                color: 'success'
                            }))
                            .catch(error => this.$store.commit('showSnackbar', { 'text': error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                            .finally(() => this.loading = false)
                    })
                    .catch(error => new Error(error))
            }
        }
    }
</script>
